import _ from "lodash";
import { createSlice } from '@reduxjs/toolkit';

const projectSlice = createSlice({
  name: 'project',
  initialState: {
    active_section: {
      id: '',
      order: '',
      type: '',
      name: '',
      code: '',
      description: '',
      products:[],
      image: '',
      steps: '',
      parent: '',
      contents:[],
    }
  },
  reducers: {
    setActiveSection: (state, action) => {
      const payload = action.payload || {};
      const normalizedProducts = Array.isArray(payload.products)
        ? [...payload.products]
        : [];

      const initialProductIds = normalizedProducts
        .map((product) => product.product?.id || product.id)
        .filter(Boolean);

      state.active_section = _.cloneDeep({
        ...payload,
        products: normalizedProducts,
        contents: Array.isArray(payload.contents) ? [...payload.contents] : [],
        initialProductIds,
      });
    },
    resetActiveSection: (state, action) => {
      state.active_section =  {
        id: '',
        order: '',
        type: '',
        name: '',
        code: '',
        description: '',
        products:[],
        image: '',
        steps: '',
        parent: '',
        contents:[],
      }
    },
    addProduct:  (state, action) => {
      const productId = action.payload.product?.id;

      const isAlreadySelected = _.some(
        state.active_section.products,
        (prod) => prod.product?.id === productId
      );

      if (isAlreadySelected) {
        state.active_section.products = state.active_section.products?.filter(
          (prod) => prod.product?.id !== productId
        );
      } else {
        state.active_section.products = [
          ...state.active_section.products,
          action.payload,
        ];
      }

      console.log("active_section:", state.active_section);
      console.log("products:", state.active_section.products);
    },
    removeProduct:  (state, action) => {
      const id = action.payload.id // Utiliser action.payload.id directement
      console.log("removeProduct - ID à supprimer:", id);
      console.log("removeProduct - Produits avant suppression:", state.active_section.products);
      
      state.active_section.products = state.active_section.products?.filter(i => i.id !== id)
      
      console.log("removeProduct - Produits après suppression:", state.active_section.products);
    },
    // removeFromSection: (state, action) => {
    //   const id = action.payload.id
    //   state.active_section.products = state.active_section.products?.filter(i => i.product.id !== id)
    //   console.log("remove payload:", action.payload)
    //   console.log("state.active_section:", state.active_section.products)
    //   // console.log("state.active_section:", JSON.stringify(state.active_section, null, 2));
    // },
    removeFromSection: (state, action) => {
      const id = action.payload.id // Utiliser action.payload.id directement
      console.log("removeFromSection - ID à supprimer:", id);
      console.log("removeFromSection - Produits avant suppression:", state.active_section.products);
      
      state.active_section.products = state.active_section.products?.filter(i => i.id !== id)

      const productId = action.payload.product?.id || action.payload.id;
      if (productId && Array.isArray(state.active_section.initialProductIds)) {
        state.active_section.initialProductIds = state.active_section.initialProductIds.filter(
          (storedId) => storedId !== productId
        );
      }
      
      console.log("removeFromSection - Produits après suppression:", state.active_section.products);
    }
  }
});

export const { setActiveSection, resetActiveSection, addProduct, removeProduct, removeFromSection } = projectSlice.actions;
export default projectSlice.reducer;

